<template>
  <div class="container">
    <!-- 搜索表单 -->
    <el-form
      :model="searchFormData"
      ref="searchFormRef"
      label-width="100px"
      class="search-form"
      :inline="true"
      @submit.prevent="handleSearch"
    >
      <el-form-item label="设备ID">
        <el-input
          v-model="searchFormData.device_id"
          placeholder="请输入设备ID"
          clearable
        />
      </el-form-item>
      <el-form-item label="用户ID">
        <el-input
          v-model="searchFormData.user_id"
          placeholder="请输入用户ID"
          clearable
        />
      </el-form-item>
      <el-form-item label="创建时间">
        <el-date-picker
          v-model="searchFormData.created_at"
          type="daterange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          clearable
          value-format="YYYY-MM-DD"
        />
      </el-form-item>
      <el-form-item label="是否处理">
        <el-select v-model="searchFormData.complete_handle" clearable placeholder="请选择" style="width: 200px;">
          <el-option label="未处理" :value="0"></el-option>
          <el-option label="已处理" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleSearch">搜索</el-button>
      </el-form-item>
    </el-form>
    <!-- 待处理数量 -->
     <div class="waiting-number-tip">等待处理记录 ： <span>{{ roleSettingMessageNumber }}</span></div>
    <!-- 设备列表 -->
    <el-table
      :data="devices"
      style="width: 100%"
      v-loading="loading"
      :header-cell-style="{ background: '#f5f7fa' }"
    >
      <el-table-column type="index" label="序号" width="80" />
      <el-table-column prop="user_id" label="用户ID" min-width="80" />
      <el-table-column prop="user_nickname" label="用户昵称" min-width="160" />
      <el-table-column
        prop="device_id"
        label="设备ID (设备mac)"
        min-width="150"
      />
      <!-- <el-table-column prop="device_name" label="设备名称" min-width="120" /> -->
      <el-table-column prop="created_at" label="创建时间" min-width="160" />
      <el-table-column prop="complete_handle" label="状态" min-width="160">
        <template #default="scope">
          <el-tag v-if="scope.row.complete_handle" type="success">已处理</el-tag>
          <el-tag v-else type="danger">未处理</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200">
        <template #default="scope">
          <el-button size="small" @click="handleDetail(scope.row)"
            >查看详情</el-button
          >
          <el-button 
            v-if="!scope.row.complete_handle" 
            size="small" 
            type="primary" 
            @click="handleComplete(scope.row)"
          >
            处理
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination
      style="margin-top: 20px; text-align: right"
      background
      layout="prev, pager, next, jumper, ->, total"
      :total="total"
      :page-size="pageSize"
      v-model:current-page="currentPage"
      @current-change="handlePageChange"
    />

    <!-- 角色配置详情对话框 -->
    <el-dialog
      v-model="detailDialogVisible"
      title="角色配置详情"
      width="600px"
      destroy-on-close
    >
      <el-form
        :model="currentDeviceRoleSetting"
        label-width="120px"
        v-loading="detailLoading"
      >
        <el-form-item label="设备ID:">
          <span style="margin-right:30px">{{ currentDeviceRoleSetting.device_id }}</span>
          <el-tag v-if="currentDeviceRoleSetting.complete_handle" type="success">已处理</el-tag>
          <el-tag v-else type="danger">未处理</el-tag>
        </el-form-item>
        <el-form-item label="助手昵称:">
          <span>{{ currentDeviceRoleSetting.assistant_name }}</span>
        </el-form-item>
        <el-form-item label="语言:">
          <span>{{ currentDeviceRoleSetting.languageStr }}</span>
        </el-form-item>
        <el-form-item label="语音:">
          <span>{{ currentDeviceRoleSetting.voiceStr }}</span>
        </el-form-item>
        <el-form-item label="角色描述:">
          <span>{{ currentDeviceRoleSetting.role_description }}</span>
        </el-form-item>
        <el-form-item label="记忆类型:">
          <span>{{ currentDeviceRoleSetting.memory_typeStr }}</span>
        </el-form-item>
        <el-form-item label="模型:">
          <span>{{ currentDeviceRoleSetting.modelStr }}</span>
        </el-form-item>
        <el-form-item label="语速:">
          <span>{{ currentDeviceRoleSetting.speech_speedStr }}</span>
        </el-form-item>
        <el-form-item label="角色速度:">
          <span>{{ currentDeviceRoleSetting.role_speedStr }}</span>
        </el-form-item>
        <el-form-item label="创建时间:">
          <span>{{ currentDeviceRoleSetting.created_at }}</span>
        </el-form-item>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="detailDialogVisible = false">关闭</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { reactive, ref, onMounted, inject } from "vue";
import { getDeviceRoleSettings, getDeviceRoleSettingById , setDeviceRoleSettingAsHandled } from "@/api/deviceRoleSetting";
import { ElMessage, ElMessageBox } from "element-plus";
import { tts_voices , languages } from "@/constants";

// 搜索表单数据
const searchFormData = reactive({
  // device_id: "",
  // user_id: "",
  // created_at: [],
});

// 搜索表单引用
const searchFormRef = ref(null);

const memoryTypes = [
  { label:'记忆体 (短期记忆)', value: 'short-memory' },
  { label: '无记忆' ,value :'no-memory' }
];

const modelOptions = [
        { label: 'Qwen3 235B（响应快速）', value: 'qwen3-235b' },
        { label: 'DeepSeek V3.1（性格丰富）', value: 'deepseek-v3.1' },
        { label: '豆包 Seed 1.6（延迟较大）', value: 'doubao-seed-1.6' },
      ];
const speechSpeeds = [
        { label: '正常', value: 'normal' },
        { label: '耐心', value: 'slow' },
        { label: '快速', value: 'fast' }
      ];
const roleSpeeds = [
        { label: '正常', value: 'normal' },
        { label: '慢速', value: 'slow' },
        { label: '快速', value: 'fast' }
      ];

// 处理完成确认
const handleComplete = (row) => {
  ElMessageBox.confirm(
    '确定要将该记录标记为已处理吗？',
    '确认处理',
    {
      confirmButtonText: '确认',
      cancelButtonText: '取消',
      type: 'warning',
    }
  ).then(() => {
    confirmComplete(row);
  }).catch(() => {
    // 用户取消操作
  });
};

// 确认处理完成
const confirmComplete = async (row) => {
  try {
    await setDeviceRoleSettingAsHandled(row.id)
    //刷新当前页数据
    fetchData();
    //刷新未处理的数量
    refreshRoleSettingMessageNumber();
    ElMessage.success("处理完成");
  } catch (error) {
    console.error("处理失败:", error);
    // ElMessage.error("处理失败");
  }
};

// 处理搜索
const handleSearch = () => {
  // 执行搜索逻辑
  console.log("搜索参数:", searchFormData);
  currentPage.value = 1;
  fetchData();
};

// // 重置搜索
// const resetSearch = () => {
//   // 清空搜索条件
//   searchFormData.device_id = "";
//   searchFormData.user_id = "";
//   searchFormData.created_at = [];
//   // 重新加载数据
//   fetchData();
// };

// 获取设备列表方法（示例）
const devices = ref([]);
const loading = ref(false);
const total = ref(0);
const pageSize = ref(10);
const currentPage = ref(1);

const fetchData = async () => {
  try {
    loading.value = true;
    const params = {
      page: currentPage.value,
      page_size: pageSize.value,
      ...searchFormData,
    };
    if(searchFormData.created_at && searchFormData.created_at.length === 2){
      params.start_time = searchFormData.created_at[0] + " 00:00:00";
      params.end_time = searchFormData.created_at[1] + " 23:59:59";
    }
    // if (searchQuery.value) {
    //   params.query = searchQuery.value;
    // }

    const response = await getDeviceRoleSettings(params);
    devices.value = response.data || [];
    total.value = response.total || 0;
  } catch (error) {
    console.error("加载设备列表失败:", error);
    ElMessage.error("加载设备列表失败");
  } finally {
    loading.value = false;
  }
};

// 页面切换处理
const handlePageChange = (page) => {
  currentPage.value = page;
  fetchData();
};

// 详情对话框相关
const detailDialogVisible = ref(false);
const detailLoading = ref(false);
const currentDeviceRoleSetting = ref({});

// 查看详情
const handleDetail = async (row) => {
  detailDialogVisible.value = true;
  detailLoading.value = true;
  try {
    const response = await getDeviceRoleSettingById(row.id);
    if (response.success) {
      currentDeviceRoleSetting.value = response.data || {};
      currentDeviceRoleSetting.value.memory_typeStr = memoryTypes.find(item => item.value === currentDeviceRoleSetting.value.memory_type)?.label || '';
      currentDeviceRoleSetting.value.modelStr = modelOptions.find(item => item.value === currentDeviceRoleSetting.value.model)?.label || '';
      currentDeviceRoleSetting.value.speech_speedStr = speechSpeeds.find(item => item.value === currentDeviceRoleSetting.value.speech_speed)?.label || '';
      currentDeviceRoleSetting.value.role_speedStr = roleSpeeds.find(item => item.value === currentDeviceRoleSetting.value.role_speed)?.label || '';
      currentDeviceRoleSetting.value.languageStr = languages.find(item => item.value === currentDeviceRoleSetting.value.language)?.label || '';
      if(currentDeviceRoleSetting.value.language){
        currentDeviceRoleSetting.value.voiceStr = tts_voices[currentDeviceRoleSetting.value.language]?.find(item => item.voice_id === currentDeviceRoleSetting.value.voice)?.voice_name || '';
      }
      
    } else {
      ElMessage.error(response.message || "获取详情失败");
      detailDialogVisible.value = false;
    }
  } catch (error) {
    console.error("获取详情失败:", error);
    ElMessage.error("获取详情失败");
    detailDialogVisible.value = false;
  } finally {
    detailLoading.value = false;
  }
};

const roleSettingMessageNumber = inject('roleSettingMessageNumber');

const refreshRoleSettingMessageNumber = inject('refreshRoleSettingMessageNumber');

onMounted(() => {
  fetchData();
});
</script>

<style lang="css" scoped>
.search-form {
  background-color: #f5f7fa;
  margin-bottom: 20px;
  border-radius: 4px;
}
.waiting-number-tip span{
  color: #f56c6c;
}
</style>